import Swiper from 'swiper/dist/js/swiper.min';

const $slider = $('.basic__slider');

if ($(window).width() <= 1024) {    
	$slider.addClass('swiper-container swiper-slider');
	$slider.find('.basic__card').addClass('swiper-slide');
    $slider.find('.swiper-slide').wrapAll('<div class="swiper-wrapper"></div>');
    
	let swiperSlider = new Swiper($slider, {
        slidesPerView: 'auto',
		scrollbar: {
			hide: false,
			draggable: true,
			el: '.slider-scrollbar',
		},
	});
}

setTimeout(function(){
    // $(".table--hidden").hide();
}, 1000);

$(".js-open-table").click(function(e){
    e.preventDefault();
    let table = $(this).attr("href");
	$(table).slideToggle();
})